import React, { useMemo } from 'react';
import classnames from 'classnames';
import { TableColumn } from 'tea-component';
import ReportTable from '../../../components/ReportTable';
import useDPSReportModule from '../../../_hooks/useDPSReportModule';
import { getRecordKeyOfMockable } from '@gp/utils/common';
import { CommonColumnBuilders } from '@gp/utils/columns';
import { getIsDisabled, resetEditorContent } from '../../../utils';
import { CARD_TITLE, buildRecord } from './utils';
import { BoolFlag } from '@gp/enums/common';

import type { IBaseProps } from '@home/types/common';
import type { IDPSReportProjectSimpleDTO } from '@gp/types/dpsReport/common';
import type { IDPSReportOtherOrMiscellaneousVO } from '@gp/types/dpsReport/v2';

interface IMiscellaneousProps extends IBaseProps {
  // 是否loading
  isLoading?: boolean;
  projectsMilestones?: IDPSReportProjectSimpleDTO[];
  // 模块数据
  value: IDPSReportOtherOrMiscellaneousVO[];
  // 模块数据更新，删除后立马更新，新增后 需要等新增这条数据编辑完整后 才会更新，页面就不需要考虑不完整的脏数据了
  onChange?: (payload: IDPSReportOtherOrMiscellaneousVO[]) => void;
}

const Miscellaneous: React.FC<IMiscellaneousProps> = (props) => {
  const { style, className, isLoading, projectsMilestones, value, onChange } = props;

  const { records, setRecords, onAdd, onDelete } = useDPSReportModule<IDPSReportOtherOrMiscellaneousVO>({
    buildRecord,
    value,
    onChange,
  });

  const columns = useMemo<TableColumn<IDPSReportOtherOrMiscellaneousVO>[]>(() => {
    const projects = projectsMilestones?.map((item) => {
      const { project_id: projectId, project } = item || {};
      return {
        text: project || '',
        value: projectId || '',
      };
    });
    return [
      CommonColumnBuilders.buildCustomizeSelectColumn({
        key: 'project_id',
        className: 'dbg-dps-report-customize-select',
        header: 'Category',
        button: (cvm: IDPSReportOtherOrMiscellaneousVO) => cvm?.project,
        placeholder: 'None',
        customizePlaceholder: 'Please input other',
        options: projects || [],
        onChange: (
          cvm: IDPSReportOtherOrMiscellaneousVO,
          key: string,
          payload: string,
          rowKey?: string,
          rowIndex?: number,
        ) => {
          const { mock_id: mockId } = cvm || {};
          const project = projectsMilestones?.find((item) => item?.project_id === payload);
          const { project: projectName, platform, image_name: imageName, cover } = project || {};
          const isCustom = !project;
          const recordIdx = records.findIndex((item) => item?.mock_id === mockId);
          const recordTmp = {
            ...records[recordIdx],
            project_id: payload || '',
            project: (isCustom ? payload : projectName) || '',
            platform: (isCustom ? [] : platform) || [],
            image_name: (isCustom ? '' : imageName) || '',
            cover: (isCustom ? '' : cover) || '',
            action_item: '',
            is_custom: isCustom ? BoolFlag.True : BoolFlag.False,
          };
          const recordsTmp = [...records.slice(0, recordIdx), recordTmp, ...records.slice(recordIdx + 1)];
          const rootNode = document.querySelector('.dbg-dps-report__miscellaneous-table-card');
          resetEditorContent(rootNode, rowIndex);
          setRecords(recordsTmp);
          onChange?.(recordsTmp);
        },
      }),
      CommonColumnBuilders.buildEditorColumn({
        key: 'action_item',
        header: 'Current Progress/Action Items',
        placeholder: 'None',
        getIsDisabled: (cvm: IDPSReportOtherOrMiscellaneousVO) => getIsDisabled(cvm),
        onChange: (cvm: IDPSReportOtherOrMiscellaneousVO, key: string, payload: string) => {
          const { mock_id: mockId } = cvm || {};
          const recordIdx = records.findIndex((item) => item?.mock_id === mockId);
          const recordTmp = {
            ...records[recordIdx],
            action_item: payload || '',
          };
          const recordsTmp = [...records.slice(0, recordIdx), recordTmp, ...records.slice(recordIdx + 1)];
          setRecords(recordsTmp);
          onChange?.(recordsTmp);
        },
      }),
    ];
  }, [projectsMilestones, records, onChange]);

  return (
    <ReportTable
      style={style}
      className={classnames('dbg-table-vertical-align-top dbg-dps-report__miscellaneous-table-card', className)}
      title={CARD_TITLE}
      isLoading={isLoading}
      // addBtnTips=""
      columns={columns}
      records={records}
      recordKey={getRecordKeyOfMockable}
      onAdd={onAdd}
      onDelete={onDelete}
    />
  );
};

export default Miscellaneous;
